import React from 'react';
import { Form } from 'semantic-ui-react';

import { Motivo } from '../tipos';

type Props = Readonly<{
    alPresionarCambiar: (motivo: Motivo) => Promise<void>;
}>;

class FormularioMotivoDeCambio extends React.Component<Props, Motivo> {
    public readonly state: Motivo = {
        tipo: 'otro',
        detalles: '',
    };

    public render() {
        const { tipo, detalles } = this.state;

        return (
            <Form onSubmit={this.reportarCambios}>
                <Form.Select
                    label='Motivo'
                    required
                    options={motivosOptions}
                    value={tipo}
                    onChange={(_, { value }) =>
                        this.setState(ps => ({ ...ps, tipo: value as Motivo['tipo'] }))
                    }
                />
                <Form.TextArea
                    label='Detalles'
                    required={tipo === 'otro'}
                    value={detalles}
                    onChange={(_, { value }) =>
                        this.setState(ps => ({ ...ps, detalles: value as string }))
                    }
                    rows={2}
                />

                <Form.Button content='Cambiar' />
            </Form>
        );
    }

    private readonly reportarCambios = () => {
        this.props
            .alPresionarCambiar(this.state)
            .then(() => this.setState({ tipo: 'otro', detalles: '' }))
            .catch();
    };
}

export default FormularioMotivoDeCambio;

const nombresDeMotivos: Record<Motivo['tipo'], string> = {
    'cambio-horario-colegio': 'Cambio en el horario de colegio',
    'cambio-horario-trabajo': 'Cambio en el horario de trabajo',
    'profesor': 'No le entiende al profesor',
    'otro': 'Otro',
};
const motivosOptions = Object.entries(nombresDeMotivos).map(([k, v]) => ({
    key: k,
    value: k,
    text: v,
}));



// WEBPACK FOOTER //
// ./src/modulos/Alumnos/paginas/FichaDeAlumno/paginas/CambiosDeCurso/componentes/FormularioMotivoDeCambio.tsx